<template>
    <div>
        <strong>How should the paid amount be handled?</strong>
        <div class="col-12 col-md-4">
            <div>
                <label>
                    <input v-model="selectedType" type="radio" :value="voucherCompensationType" name="compensation_type"
                           @change="select"/>
                    Create voucher for:
                </label>
                <input v-model="voucherAmount" type="text"
                       :disabled="selectedType !== this.voucherCompensationType"
                       name="compensation_amount">
            </div>

            <div>
                <label>
                    <input v-model="selectedType" type="radio" :value="refundCompensationType" name="compensation_type"
                           @change="select"/>
                    Refund for:
                </label>
                <input v-model="refundAmount" type="text"
                       :disabled="selectedType !== this.refundCompensationType"
                       name="compensation_amount">
            </div>

            <div>
                <label>
                    <input v-model="selectedType" type="radio" :value="noCompensationCompensationType"
                           name="compensation_type" @change="select"/>
                    No compensation
                </label>
            </div>

            <div>
                <label>
                    <input v-model="selectedType" type="radio" :value="orderChangeCompensationType"
                           name="compensation_type" @change="select"/>
                    Order change
                </label>
            </div>
        </div>

        <div v-if="!compensationAmountIsValid" class="col-md-4 alert alert-warning text-dark fade show">
            The compensation amount can not be negative or higher than the order amount.
        </div>
    </div>
</template>

<script>

export default {
    name: "Compensation",

    props: {
        maxAmount: {
            required: true
        },
        voucherCompensationType: {
            required: true
        },
        refundCompensationType: {
            required: true
        },
        noCompensationCompensationType: {
            required: true
        },
        orderChangeCompensationType: {
            required: true
        },
        type: {
            default: null
        },
        amount: {
            default: 0
        }
    },

    data: function () {
        return {
            compensation: {
                type: this.type,
                amount: this.amount,
            },
            selectedType: null
        }
    },

    computed: {
        voucherAmount: {
            get() {
                return this.compensation.type === this.voucherCompensationType ? this.compensation.amount : '';
            },
            set(value) {
                if (this.compensation.type === this.voucherCompensationType) {
                    this.compensation.amount = value;
                }
            }
        },

        refundAmount: {
            get() {
                return this.compensation.type === this.refundCompensationType ? this.compensation.amount : '';
            },
            set(value) {
                if (this.compensation.type === this.refundCompensationType) {
                    this.compensation.amount = value;
                }
            }
        },

        compensationAmountIsValid() {
            if (this.compensation.type === this.noCompensationCompensationType || this.compensation.type === null || this.compensation.type === this.orderChangeCompensationType) {
                return true;
            }

            return this.compensation.amount >= 0 && this.compensation.amount <= this.maxAmount;
        }
    },

    methods: {
        select() {
            this.reset()
            this.compensation.type = this.selectedType;
            this.compensation.amount = this.refundAmount;

            if (this.selectedType === this.noCompensationCompensationType || this.selectedType === this.orderChangeCompensationType) {
                this.compensation.amount = 0;
            }
        },

        reset() {
            this.compensation.type = null;
            this.compensation.amount = null;
        }
    }

}
</script>
